import React, { useState, useEffect } from "react";
import { MDBRow, MDBBtn } from "mdb-react-ui-kit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Autocomplete from "@mui/material/Autocomplete";
import { Chip } from "@mui/material";
import { Link } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
//
import { validate } from "../components/login/validate";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import ButtonGroupBusinness from "../components/ButtonGroupBusinness/ButtonGroupBusinness";
import RegisterBusiness from "./RegisterBusiness";
// img
import imgg from "../images/register-business/02.png";
import close from "../images/header/close.png";
import iconn from "../images/next-left.png";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const RegisterBusinessStep2 = (props) => {
  const [render, setRender] = useState(false);
  const [dataCome, setDataCome] = useState(false);
  const [dataCome2, setDataCome2] = useState(false);

  const [changedCid, setChangedCid] = useState(true);

  const [disable, setDisable] = useState(false);

  const [categories, setCategories] = useState([]);
  const [cid, setcid] = useState([]);
  const [childCat, setChildCat] = useState([]);

  const [buttonGroupsId, setbuttonGroupsId] = useState([]);

  // group validate
  const [groupValidate, setGroupValidate] = useState(true);
  const [showGV, setShowGV] = useState(false);
  const [emptyInput, setemptyInput] = useState(true);

  // validate
  const [data, setData] = useState({
    categoryy: "",
    inputValue: "",
  });
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [list3, setList3] = useState([]);
  const listHandler = (newValue) => {
    if (list3.length < 1) {
      if (!list3.includes(newValue.title)) {
        setList3([...list3, newValue.title]);
      }
    }
  };

  const deleteHandler = (num) => {
    if (list3.length > 0) {
      setList3(list3.filter((item) => item !== num));
    }
    setValue(null);
    setData({ ...data, categoryy: "" });
  };

  // for button group
  const [showBtns, setShowBtns] = useState(false);

  // validate
  useEffect(() => {
    setErrors(validate(data, "register-business-s2"));
  }, [data, touched]);

  // for api
  const [CatIdsApi, setCatIdsApi] = useState(null);
  // const [btnGroupsId, setbtnGroupsId] = useState(null);

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Parentid: cid,
    Authorization: "Bearer " + getCookie("token"),
  };

  const submitHandler = (event) => {
    event.preventDefault();

    var btnGroupsId = "";

    if (!Object.keys(errors).length) {
      setDisable(true);
      // success
      if (
        groupValidate
        //  || emptyInput
      ) {
        // const itemsPost1 = JSON.parse(
        //   localStorage.getItem("OwnerDetail")
        // ).BizId;
        const itemsPost2 = JSON.parse(localStorage.getItem("CatId"));

        if (buttonGroupsId.length == 0) {
          btnGroupsId = "";
        } else {
          for (let index = 0; index < buttonGroupsId.length; index++) {
            const element = buttonGroupsId[index];
            btnGroupsId = btnGroupsId + buttonGroupsId[index] + ",";
          }
        }
        // else if (buttonGroupsId.length == 1) {
        //   btnGroupsId = buttonGroupsId[0];
        // } else if (buttonGroupsId.length == 2) {
        //   btnGroupsId = buttonGroupsId[0] + "," + buttonGroupsId[1];
        // } else if (buttonGroupsId.length == 3) {
        //   btnGroupsId =
        //     buttonGroupsId[0] +
        //     "," +
        //     buttonGroupsId[1] +
        //     "," +
        //     buttonGroupsId[2];
        // }

        const dataPost = {
          // CatId: itemsPost2,
          // CatName: CatIdsApi,

          bId: getCookie("BizId"),
          parentId: value.cId,
          // catId: itemsPost2,// for other input
          catIds: btnGroupsId,
          // catName: CatIdsApi,// for other input
        };

        axios
          .post(
            configData.API_DOMAIN +
              `/api/v1/Businesses/${getCookie("BizUuid")}/categories`,
            dataPost,
            {
              headers: header,
            }
          )
          .then((response) => {
            setDisable(false);
            if (response.data.isSuccess) {
              // success
              localStorage.setItem(
                "CatId",
                JSON.stringify(response.data.data.catId)
              ); //set local
              // setcookie to use in dashboard
              setCookie("CatId", response.data.data.catId, 1);

              localStorage.setItem(
                "CatId-step3",
                JSON.stringify(cid + "," + btnGroupsId)
              ); //set local

              localStorage.removeItem("step2-back-data"); // remove data of step2 saved by back button

              props.history.push({
                pathname: "/register-business-step3",
                state: cid + "," + btnGroupsId,
              });
            }
          })
          .catch((error) => {
            // alert(error);
          });
      } else {
        setShowGV(true);
        setDisable(false);
      }
    } else {
      setTouched({
        categoryy: true,
      });
      setDisable(false);
    }
  };

  const backHandler = () => {
    const data = {
      parentCat: value ? [value] : [],
      childCat: value ? buttonGroupsId : [],
    };
    localStorage.setItem("step2-back-data", JSON.stringify(data)); //set step2 loocal storage

    props.history.push({
      pathname: "/register-business-step1",
    });
  };

  const [locakChild, setlocakChild] = useState(false);
  const [items, setItems] = useState([]);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step2",
    Authorization: "Bearer " + getCookie("token"),
  };

  // api
  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");

    setDataCome(false);
    setDataCome2(false);

    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/categories`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number -- comment foe step 1
            else if (stepStatus.regStep < 2) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              let findCId = "";

              if (JSON.parse(localStorage.getItem("step2-back-data"))) {
                // set data from local storage to states
                let dataLocal = JSON.parse(
                  localStorage.getItem("step2-back-data")
                );

                for (
                  let index = 0;
                  index < dataLocal.parentCat.length;
                  index++
                ) {
                  const element = dataLocal.parentCat[index];
                  setcid(element.cId);
                  setList3([element.title]);
                  setValue(element);

                  findCId = element.cId;
                }

                setShowBtns(true);
                for (let i = 0; i < dataLocal.childCat.length; i++) {
                  const element = dataLocal.childCat[i];
                  setItems((items) => [...items, element]);
                }
              } else {
                // set data from api to states
                for (let index = 0; index < data.parentCat.length; index++) {
                  const element = data.parentCat[index];
                  setcid(element.cId);
                  setList3([element.title]);
                  setValue(element);

                  findCId = element.cId;
                }
                setChildCat(data.childCat);
                setShowBtns(true);

                for (let i = 0; i < data.childCat.length; i++) {
                  const element = data.childCat[i];
                  if (element.isSelected) {
                    setItems((items) => [...items, element.cId]);
                  }
                }
              }

              // api to get parent category data
              axios
                .get(configData.API_DOMAIN + "/api/v1/Categories", {
                  headers: header,
                })
                .then((response) => {
                  setDataCome(true);
                  setDataCome2(true);

                  if (response.data.isSuccess) {
                    setCategories(response.data.data);

                    if (findCId !== "") {
                      const findCat = response.data.data.find(
                        (item) => item.cId == findCId
                      );
                      setChildCat(findCat.children);
                    }
                  }
                })
                .catch((error) => {
                  // alert(error);
                });
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });

      setRender(true);
    }
  }, []);

  useEffect(() => {
    if (locakChild) {
      setDataCome2(false);
      axios
        .get(configData.API_DOMAIN + "/api/v1/Categories", { headers: header })
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;
            const findCat = data.find((item) => item.cId == cid);
            setChildCat(findCat.children);
            setDataCome2(true);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      setlocakChild(false);
    }
  }, [cid, changedCid]);

  //setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      " domain=en-biz.gishniz.com; path=/";
    // " domain=en-biz.gishniz.app; path=/";
  }
  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                <div className="register-steps-right">
                  <h1 className="rb-step2-tit1">انتخاب دسته‌بندی کسب‌وکار</h1>
                  <h2 className="rb-step1-tit2">
                    انتخاب دسته‌بندی مناسب به بهتر پیدا کردن کسب‌وکار شما کمک
                    می‌کند.
                  </h2>
                  <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                      <div dir="rtl">
                        {dataCome ? (
                          <>
                            <div className=" auto8 width-sm-100">
                              <Autocomplete
                                value={value}
                                onChange={(event, newValue) => {
                                  setChangedCid(!changedCid);
                                  setItems([]);
                                  setbuttonGroupsId([]);
                                  setValue(newValue);
                                  setChildCat([]);
                                  setlocakChild(true);
                                  setcid(newValue.cId);
                                  listHandler(newValue);
                                  setShowBtns(true);
                                  setData({
                                    ...data,
                                    categoryy: newValue.title,
                                    // objectValue: newValue,
                                  });
                                }}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                  setInputValue(newInputValue);
                                  setData({
                                    ...data,
                                    categoryy: newInputValue,
                                  });
                                }}
                                disabled={list3.length > 0}
                                // open={true}
                                popupIcon={
                                  <img
                                    src={iconn}
                                    className="icon-ib"
                                    alt="category img"
                                  />
                                }
                                disableClearable
                                disablePortal
                                openOnFocus={true}
                                id="auto8"
                                options={categories}
                                getOptionLabel={(option) => option.title}
                                className=""
                                sx={{
                                  fontFamily: "inherit",
                                }}
                                renderInput={(params) => (
                                  <div className="d-flex width-sm-100">
                                    <TextField
                                      id="auto8"
                                      className={
                                        errors.categoryy && touched.categoryy
                                          ? "auto-error"
                                          : ""
                                      }
                                      {...params}
                                      label=" مثال: رستوران، وکالت،پزشکی"
                                      required
                                    >
                                      {" "}
                                    </TextField>
                                  </div>
                                )}
                              />
                              {errors.categoryy && touched.categoryy && (
                                <span className="input-error-auto me-1">
                                  {errors.categoryy}
                                </span>
                              )}
                            </div>
                            {list3.map((item) => (
                              <Chip
                                id="rb-chip"
                                // dir="ltr"
                                label={item}
                                onDelete={() => {
                                  if (list3.length == 1) {
                                    deleteHandler(item);
                                    setData({
                                      categoryy: "",
                                      // objectValue: {}
                                    });
                                    setShowBtns(false);
                                  } else {
                                    deleteHandler(item);
                                  }
                                }}
                                deleteIcon={
                                  <img
                                    src={close}
                                    alt="X"
                                    className="s2-chip-icon"
                                  />
                                }
                                key={item}
                              />
                            ))}
                          </>
                        ) : (
                          <>
                            <Skeleton
                              className="profile-Skeleton "
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                            <Skeleton
                              id="rb-chip"
                              className="bg-skeleton"
                              variant="rectangular"
                              width={170}
                              animation="wave"
                            />
                          </>
                        )}
                        {/* second part */}
                        {dataCome2 ? (
                          <div
                            className={showBtns ? "d-block rb2-bgb" : "d-none"}
                          >
                            {childCat.length > 0 && (
                              <ButtonGroupBusinness
                                itemss={items}
                                data={childCat}
                                buttonGroupsId={buttonGroupsId}
                                onChangebuttonGroupsId={setbuttonGroupsId}
                                groupValidate={groupValidate}
                                setGroupValidate={setGroupValidate}
                                showGV={showGV}
                                CatIdsApi={CatIdsApi}
                                setCatIdsApi={setCatIdsApi}
                                emptyInput={emptyInput}
                                setemptyInput={setemptyInput}
                              />
                            )}
                          </div>
                        ) : (
                          <>
                            <div className="d-flex justify-content-center justify-content-md-start mt-79">
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-start">
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                              <Skeleton
                                id="rb-chip"
                                className="bg-skeleton mt-3"
                                variant="rectangular"
                                height={30}
                                width={100}
                                animation="wave"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </ThemeProvider>
                  </CacheProvider>

                  <div className=" mt-0">
                    {dataCome ? (
                      <div className="rb-steps-btns">
                        <Link
                          // to="/register-business-step1"
                          className="rb-steps-btn1 hov-shadow"
                          onClick={backHandler}
                        >
                          مرحله قبلی
                        </Link>
                        <MDBBtn
                          disabled={disable}
                          onClick={submitHandler}
                          className="rb-steps-btn2 hov-shadow"
                        >
                          مرحله بعدی
                        </MDBBtn>
                      </div>
                    ) : (
                      <div className="rb-steps-btns">
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                <img
                  className="register-business-img"
                  src={imgg}
                  alt="register business"
                />
              </div>
            </MDBRow>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RegisterBusinessStep2;
